// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2m9RY","productName":"Table_productName__1XslG"};